import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RouteComponentProps, useHistory } from "react-router-dom";
import { ApplicationState } from "../../store";
import * as LoginActions from "../../store/loginService/actions";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { Link } from "react-router-dom";
import FamilyProtectionService from "../Family/FamilyProtectionService";
import FamilyProtectionServiceFPS from "../Family/FamilyProtectionServiceFPS";
import BannerMessage from "../Dashboard/BannerMessage";
import ErrorBoundary from "../common/ErrorBoundary";
import parse from "html-react-parser";
import { useAreServicesActive } from "../../util/CommonServices";
import { ezsServiceIds } from "../../config/UserServicesList";
import { DialogComponent } from "../common/DialogComponent";
import DashboardSecurityQuestionDialog from "../Dialogs/DashboardSecurityQuestionDialog";
import * as MyAccountActions from "../../store/myAccount/actions";
import * as BreachActions from "../../store/breachService/actions";
import LoggedInUser from "./LoggedInUser";
import { CommonContext } from "../../CommonContextProvider";
import LanguagePreferenceDialog from "../Dialogs/LanguagePreferenceDialog";
import { useTranslation } from "react-i18next";
import { Navbar } from "../Navbar";

type TopHeaderProps = RouteComponentProps<{}>;

const TopHeader: React.FunctionComponent<TopHeaderProps> = (props) => {
    const dispatch = useDispatch();
    const { redirectPageTo }: any = useContext(CommonContext);
    const [isLanguagePreferenceDialogOpen, setLanguagePreferenceDialogOpen] = useState(false);
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const partnerLanguageOptions: any = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const [topNavButtonText, setTopNavButtonText] = useState("<i class='las la-angle-down'></i>");
    const getAccountInformation = () => dispatch(MyAccountActions.actionCreators.getAccountInformation(false));
    const showTopNav: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.navigationTop
            ? state.configurationState.configuration.partnerConfig.navigationTop
            : false
    );
    const [selectedNavElement, setSelectedNavElement] = useState("");
    const isAccountInformationLoading: boolean = useSelector((state: ApplicationState) =>
        state.myAccountServiceState ? state.myAccountServiceState.isLoading : false
    );
    const isSSOUser: boolean = useSelector((state: ApplicationState) =>
        state.myAccountServiceState && state.myAccountServiceState._unifiedAccountInfo && state.myAccountServiceState._unifiedAccountInfo.isSSOUser
            ? state.myAccountServiceState._unifiedAccountInfo.isSSOUser
            : false
    );
    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );
    const isAVGId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2659
                ? true
                : false
            : false
    );

    const isAVGTestId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2662
                ? true
                : false
            : false
    );
    const isCreditSesamePartnerId= useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2626
                ? true
                : false
            : false
    );

    const [state, setState] = useState({ isNoSelectedQuestion: false });
    const [partnerName, setPartnerName] = useState("");
    const redirectToHome = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.partnerModes &&
            state.configurationState.configuration.partnerConfig.partnerModes?.indexOf("PartnerMode.LoginOption.None") > 0
        ) {
            return true;
        }
        return false;
    });
    const originalSiteUrl: any = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.originSiteUrl
        ) {
            return state.configurationState.configuration.partnerConfig.originSiteUrl;
        } else {
            return "";
        }
    });
    const SetPreferencedLanguage = (leng: any, updateUsersLang: boolean) => dispatch(LoginActions.actionCreators.SetPreferencedLanguage(leng, updateUsersLang));
    const preferencedLanguage = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.preferencedLanguage ? state.loggedInUser.userInfo?.preferencedLanguage : "en"
    );

    const partnerProvider = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.partnerProvider === "IDF"
        ) {
            return "IDF";
        }
        return "EZS";
    });
    const isPrimaryAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false
    );
    const isFamilyProtectionServiceActive = useAreServicesActive([ezsServiceIds.familyProtectionService]);
    const isFamilyProtectionPlusServiceActive = useAreServicesActive([ezsServiceIds.familyProtectionPlus]);

    const brandingOptions = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration?.partnerConfig?.brandingOption) {
            return {
                imagePath: state.configurationState.configuration?.partnerConfig?.brandingOption?.imagePath,
                associationText: state.configurationState.configuration?.partnerConfig?.brandingOption?.associationText,
                secondaryText: state.configurationState.configuration?.partnerConfig?.brandingOption?.secondaryText,
            };
        } else {
            return {
                imagePath: "",
                associationText: "",
                secondaryText: "",
            };
        }
    });

    const getQuestionInfo = useSelector((state: ApplicationState) => {
        if (state.myAccountServiceState && state.myAccountServiceState.securityQueData) {
            return {
                securityQueData: state.myAccountServiceState.securityQueData,
            };
        } else {
            return {
                securityQueData: [],
            };
        }
    });

    const partnerDisplayName: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ""
    );

    const partnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : ""
    );

    const getFamilyService = () => {
        if (isFamilyProtectionServiceActive) {
            return <FamilyProtectionServiceFPS />;
        } else {
            return <FamilyProtectionService history={props.history} />;
        }
    };

    const requestLogout = (event: any) => {
        event.preventDefault();
        if (redirectToHome) {
            dispatch(LoginActions.actionCreators.logout(props.history, originalSiteUrl));
        } else {
            dispatch(LoginActions.actionCreators.logout(props.history));
        }
        dispatch(ConfigurationActions.actionCreators.getRedirectTokenAction(""));
    };

    const [showDashboardSecurityQuestionDialog, setShowDashboardSecurityQuestionDialog] = useState(
        !isAccountInformationLoading && !isSSOUser && state.isNoSelectedQuestion && partnerProvider !== "IDF"
    );

    useEffect(() => {
        setShowDashboardSecurityQuestionDialog(!isSSOUser && state.isNoSelectedQuestion && partnerProvider !== "IDF");
    }, [isAccountInformationLoading, isSSOUser, state.isNoSelectedQuestion]);

    useEffect(() => {
        document.getElementsByTagName("html")[0].style.overflowY = "auto";
        getAccountInformation();
        if (showTopNav) {
            addStylingForHeaderForTOpNav();
        }
        if (getQuestionInfo && getQuestionInfo.securityQueData && getQuestionInfo.securityQueData.selectedSecurityQuestion === null) {
            setState({ ...state, isNoSelectedQuestion: true }); 
        }
    }, []);

    useEffect(() => {
        if (partnerId === 2649) {
            setPartnerName("Transunion");
        } else {
            setPartnerName(partnerDisplayName);
        }
    }, [partnerId]);

    const addStylingForHeaderForTOpNav = () => {
        document.getElementsByTagName("header")[0].classList.add("transparent-top-nav");
    };

    const toggleTopNav = () => {
        const element = document.getElementById("top-nav-bar");

        if (element?.classList.contains("top-nav-hide-mobile")) {
            setTopNavButtonText("<i class='las la-angle-up'></i>");
            element?.classList.remove("top-nav-hide-mobile");
            element?.classList.add("full-height");
            document.getElementsByTagName("html")[0].style.overflowY = "hidden";
            document.getElementsByTagName("header")[0].classList.remove("transparent-top-nav");
            setSelectedNavElement(document.getElementsByClassName("nav-active")[0].getElementsByClassName("nav-text")[0].innerHTML);
        } else {
            element?.classList.remove("full-height");
            setTopNavButtonText("<i class='las la-angle-down'></i>");
            element?.classList.add("top-nav-hide-mobile");
            document.getElementsByTagName("header")[0].classList.add("transparent-top-nav");
            setSelectedNavElement("");
            document.getElementsByTagName("html")[0].style.overflowY = "auto";
        }
    };

    useEffect(() => {
        languageChange(preferencedLanguage, false);
    }, [preferencedLanguage]);

    const languageChange = (languageSelected: string, updateUsersPreferedLang: boolean) => {
        i18nLang.changeLanguage(languageSelected);
        SetPreferencedLanguage(languageSelected, updateUsersPreferedLang);
    };
    const selectedLang = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.preferencedLanguage ? state.loggedInUser.userInfo?.preferencedLanguage : "en"
    );

    const closeSecurityQuestionDialog = () => {
        setState({ ...state, isNoSelectedQuestion: false });
        setShowDashboardSecurityQuestionDialog(false);
    };
    const openLanguagePreferenceDialog = () => {
        setLanguagePreferenceDialogOpen(true);
    };
    const closeLanguagePreferenceDialog = () => {
        setLanguagePreferenceDialogOpen(false);
    };
    const requestBreachService = () => {
        setTimeout(() => {
            dispatch(BreachActions.actionCreators.requestBreachService());
        }, 1000);
    };

    const skipToMainContent = () => {
        const initialUrl = sessionStorage.getItem("initialUrl");
        if (typeof initialUrl === "string" && decodeURIComponent(initialUrl) !== window.location.href) {
            window.location.href = decodeURIComponent(initialUrl);
        } else {
            const mainElement = document.getElementById('main-content');
            const linkAndButtonElements = mainElement.querySelectorAll('a, button, [role="button"], [role="link"], input');
            const linkAndButtonElementsArray = Array.from(linkAndButtonElements);
            const filteredElements = linkAndButtonElementsArray.filter(el => (el.getAttribute('aria-label') !== 'Show Menu Options'));
            const filteredLinkAndButtonElements = filteredElements.filter(el => (el.getAttribute('tabindex') !== '-1'));
            const firstElement = filteredLinkAndButtonElements[0];
            if (firstElement) {
                firstElement.focus();
            }
        }
    };

    return (
        <React.Fragment>
            <header className={`${!showTopNav ? "header-fixed" : ""}`}>
                <div className="l-page-container">
                    <button id="skip-main-btn" className="skip-main" onClick={() => skipToMainContent()}>
                        {tLang("skipToMainContent.label")}
                    </button>

                    <div
                        className={`row ${showTopNav ? "center-xs" : "between-xs"} full-width`}
                        onClick={
                            showTopNav
                                ? () => {
                                      toggleTopNav();
                                  }
                                : () => {}
                        }
                    >
                        {!showTopNav && (
                            <div className="col-xs flex-grow-null">
                                <div className="row middle-xs">
                                    <div className="hide-desktop">
                                        <div className="mobile-nav-button">
                                            <button
                                                type="button"
                                                className="btn-default btn-icon-only "
                                                id="nav-main-btn"
                                                aria-expanded="false"
                                                aria-controls="nav-main"
                                                aria-label="Toggle Menu"
                                            >
                                                <span className="btn-icon" aria-hidden="true">
                                                    <em className="las la-bars"></em>
                                                </span>
                                                <span className="btn-text">
                                                    <span className="sr-only">View Main Menu</span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="col-xs col-no-gutter hide-mobile flex-grow-null">
                                        {!isCreditSesamePartnerId && 
                                        <div className="logo-container">
                                            <a href="dashboard" title="Return to Homepage1" className="logo-link">
                                                <img src={brandingOptions?.imagePath} alt={`${partnerName} Logo`} />
                                            </a>
                                        </div>
                                        }
                                    </div>
                                    <div className="col-xs col-no-gutter hide-mobile">
                                        <div className="secondary-container">
                                            <div className="secondary-text">{brandingOptions?.associationText}</div>
                                            <div className="secondary-logo">{parse(brandingOptions?.secondaryText || "", {})}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {showTopNav && (
                            <div className="hide-top-nav">
                                <div className="col-xs col-no-gutter flex-grow-null" id="logo-container">
                                    <div className="logo-container">
                                        <a href="dashboard" title="Return to Homepage1" className="logo-link">
                                            <img src={brandingOptions?.imagePath} alt={`${partnerName} Logo`} />
                                        </a>
                                    </div>
                                </div>
                                <div className="mobile-view-top-nav row">
                                    <div className="top-nav-text">
                                        <h1 style={{ margin: "10px" }} className="title-page">
                                            <span dangerouslySetInnerHTML={{ __html: selectedNavElement }}></span>
                                        </h1>
                                    </div>
                                    <div className="mobile-nav-button">
                                        <button
                                            type="button"
                                            className="btn-default btn-no-padding btn-icon-only btn-secondary-outline"
                                            id="top-nav-main-btn"
                                            aria-expanded="false"
                                            aria-controls="nav-main"
                                        >
                                            <span
                                                className="btn-icon"
                                                id="top-nav-text"
                                                aria-hidden="true"
                                                dangerouslySetInnerHTML={{ __html: topNavButtonText }}
                                            ></span>
                                            <span className="btn-text">
                                                <span className="sr-only">View Main Menu</span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                        {showTopNav && (
                            <div className="top-nav-hide-mobile" id="top-nav-bar">
                                {" "}
                                <Navbar
                                    renderFamilyService={
                                        (isFamilyProtectionPlusServiceActive || isFamilyProtectionServiceActive || !isPrimaryAccount) && getFamilyService
                                    }
                                    requestLogout={requestLogout}
                                />
                                <div className="logo-container" style={{ textAlign: "center" }} id="hide-logo">
                                    <a href="dashboard" title="Return to Homepage1" className="logo-link">
                                        <img src={brandingOptions?.imagePath} alt={`${partnerName} Logo`} />
                                    </a>
                                </div>
                            </div>
                        )}
                        {!showTopNav && (
                            <div className="col-xs flex-grow-null">
                                <div className="user-container">
                                    <div className="m-pop-under">
                                        <ErrorBoundary componentName="LoggedInUser" type="hideError" replaceDefaultContent={false} errorMsg="">
                                            <LoggedInUser />
                                        </ErrorBoundary>

                                        <div id="user-profile" className="pop-under-content user-profile">
                                            <div>
                                                <h4 className="sr-only">User Options</h4>
                                                <ul role="menu" className="submenu-links">
                                                    {!!partnerLanguageOptions && partnerLanguageOptions?.length >= 2 && (
                                                        <>
                                                            {" "}
                                                            <li role="menuitem">
                                                               <h5 className="section_title">{tLang("dashboard.userMenuDropdown.accountLanguage")}</h5>
                                                            </li>
                                                            <li role="menuitem" className="language-preference">
                                                                <a
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        openLanguagePreferenceDialog();
                                                                    }}
                                                                >
                                                                    <em className="las la-globe"></em>
                                                                    {selectedLang == "en" ? "English" : "French"}
                                                                </a>
                                                            </li>{" "}
                                                        </>
                                                    )}
                                                    <li role="menuitem">
                                                        <h5 className="section_title">{tLang("dashboard.userMenuDropdown.navigation")}</h5>
                                                    </li>
                                                   
                                                    <li role="menuitem" className="sub-links">
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                redirectPageTo("/manage-account/my-account");
                                                                requestBreachService();
                                                            }}
                                                        >
                                                            {isAvastId || isAVGId || isAVGTestId ? "Manage Profile" : tLang("dashboard.userMenuDropdown.manageAcc")}
                                                        </a>
                                                    </li>
                                                    <li role="menuitem" className="sub-links">
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                redirectPageTo("/manage-account/my-services");
                                                                requestBreachService();
                                                            }}
                                                        >
                                                            {tLang("dashboard.userMenuDropdown.manageService")}
                                                        </a>
                                                    </li>
                                                    <li role="menuitem" className="sub-links">
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                redirectPageTo("/manage-account/protection-plan");
                                                                requestBreachService();
                                                            }}
                                                        >
                                                            {tLang("dashboard.userMenuDropdown.protectionPlan")}
                                                        </a>
                                                    </li>

                                                    <li role="menuitem" className="sub-links">
                                                        <Link to="" onClick={(e) => requestLogout(e)}>
                                                            {tLang("dashboard.userMenuDropdown.logout")}
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>

                                            <ErrorBoundary componentName="FamilyMember" type="hideError" replaceDefaultContent={false} errorMsg="">
                                                {/*<FamilyAccount history={props.history} />*/}
                                                {getFamilyService()}
                                            </ErrorBoundary>

                                            <div id="user-profile" className="pop-under-content user-profile">
                                                <div>
                                                    <h4 className="sr-only">User Options</h4>
                                                    <ul role="menu" className="submenu-links">
                                                        {!!partnerLanguageOptions && partnerLanguageOptions?.length >= 2 && (
                                                            <>                                                              
                                                                <li role="menuitem">
                                                                    <h5 className="section_title">{tLang("dashboard.userMenuDropdown.accountLanguage")}</h5>
                                                                </li>

                                                                <li role="menuitem" className="language-preference">
                                                                    <a
                                                                        href="#"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            openLanguagePreferenceDialog();
                                                                        }}
                                                                    >
                                                                        <em className="las la-globe"></em>
                                                                        {selectedLang === "en" ? "English" : "French"}
                                                                    </a>
                                                                </li>
                                                            </>
                                                        )}
                                                      
                                                        <li role="menuitem">
                                                            <h5 className="section_title">{tLang("dashboard.userMenuDropdown.navigation")}</h5>
                                                        </li>

                                                        <li role="menuitem" className="sub-links">
                                                            <a
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    redirectPageTo("/manage-account/my-account");
                                                                }}
                                                            >
                                                                {tLang("dashboard.userMenuDropdown.manageAcc")}
                                                            </a>
                                                        </li>
                                                        <li role="menuitem" className="sub-links">
                                                            <a
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    redirectPageTo("/manage-account/my-services");
                                                                }}
                                                            >
                                                                {tLang("dashboard.userMenuDropdown.manageService")}
                                                            </a>
                                                        </li>
                                                        <li role="menuitem" className="sub-links">
                                                            <a
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    redirectPageTo("/manage-account/protection-plan");
                                                                }}
                                                            >
                                                                {tLang("dashboard.userMenuDropdown.protectionPlan")}
                                                            </a>
                                                        </li>

                                                        <li role="menuitem" className="sub-links">
                                                            <Link to="" onClick={(e) => requestLogout(e)}>
                                                                {tLang("dashboard.userMenuDropdown.logout")}
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {showDashboardSecurityQuestionDialog && (
                        <DialogComponent hideCloseButton={true} dialogId="dialog-dashboard-security-question" title="" closeDialog={() => {}}>
                            <DashboardSecurityQuestionDialog securityQueData={getQuestionInfo.securityQueData} onClose={() => closeSecurityQuestionDialog()} />
                        </DialogComponent>
                    )}

                    {isLanguagePreferenceDialogOpen && (
                        <DialogComponent hideCloseButton={false} dialogId="dialog-language-preference" title="Language Preference Dialog" closeDialog={closeLanguagePreferenceDialog}>
                            <LanguagePreferenceDialog closeDialog={closeLanguagePreferenceDialog} changeLanguage={languageChange} />
                        </DialogComponent>
                    )}
                </div>
            </header>

            {/* Banner alert message*/}
            <BannerMessage layout={"default"} />
        </React.Fragment>
    );
};

export default TopHeader;
